import _convertWordMapToSubtitles from "../functions/special/convertWordMapToSubtitles.js";
import _convertWordMapToTranscript from "../functions/special/convertWordMapToTranscript.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _Event from "../classes/event.js";
const Event = _Event;
const getFormatOptions = _getFormatOptions;
const convertWordMapToTranscript = _convertWordMapToTranscript;
const convertWordMapToSubtitles = _convertWordMapToSubtitles;
export default {
  decode: function (input, options) {
    let events = [],
      wordMap = [],
      decodingOptions = getFormatOptions(options.formatOptions);
    let fileJson = JSON.parse(input);
    let importType = decodingOptions["Import Type"] || "subtitle";
    let maxLines = decodingOptions["Max Lines"] || 2;
    let maxChars = decodingOptions["Max Characters"] || 32;
    if (Array.isArray(fileJson.results)) {
      /* The last result may be a summary containing every word with speaker tags */
      let lastWords = fileJson.results[fileJson.results.length - 1]?.alternatives?.[0]?.words;
      let sourceWords = [];
      if (Array.isArray(lastWords) && lastWords.length > 0 && lastWords[0].speakerTag !== undefined) {
        sourceWords = lastWords;
      } else {
        fileJson.results.forEach(result => {
          (result.alternatives || []).forEach(alternative => {
            if (Array.isArray(alternative.words)) {
              sourceWords.push(...alternative.words);
            }
          });
        });
      }
      sourceWords.forEach(word => {
        addWord(wordMap, word.word, word.startTime, word.endTime, word.confidence, word.speakerTag);
      });
    } else if (Array.isArray(fileJson.words)) {
      fileJson.words.forEach(word => {
        if (word.type && word.type !== "word") {
          return;
        }
        addWord(wordMap, word.text || word.word, word.start, word.end, word.confidence, word.speaker_id);
      });
    }

    /* Words can share a start time, so only drop exact repeats */
    let seenWords = new Set();
    wordMap = wordMap.filter(word => {
      let key = `${word.start}|${word.end}|${word.text}`;
      if (seenWords.has(key)) {
        return false;
      }
      seenWords.add(key);
      return true;
    });
    if (importType === "word map") {
      events = wordMap;
    } else if (importType === "transcription") {
      events = convertWordMapToTranscript(wordMap, maxLines, maxChars, options.window);
    } else {
      events = convertWordMapToSubtitles(wordMap, maxLines, maxChars, options.window);
    }
    return events;
  },
  encode: function (eventGroup, options) {
    throw new Error("AI transcript files are not supported for encoding by Closed Caption Converter.");
  },
  preProcess: {
    encode: function (eventGroup) {
      return eventGroup;
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      eventGroup.events.sort((eventA, eventB) => eventA.start - eventB.start);
      eventGroup.events = eventGroup.events.filter((event, index, events) => {
        if (index > 0) {
          return event.start !== events[index - 1].start;
        } else {
          return true;
        }
      });
      return eventGroup;
    }
  }
};
function addWord(wordMap, text, startValue, endValue, confidence, speaker) {
  let start = parseTime(startValue);
  let end = parseTime(endValue);
  text = (text || "").trim();
  if (!text || !Number.isFinite(start)) {
    return;
  }
  wordMap.push(new Event({
    start: start,
    end: Math.max(Number.isFinite(end) ? end : start, start + 0.1),
    text: text,
    confidence: confidence !== undefined ? confidence : false,
    speakers: speaker !== undefined && speaker !== null ? [speaker] : []
  }));
}

/* Accepts seconds as a number, "12.400s"/"13s" strings, or { seconds, nanos } objects */
function parseTime(value) {
  if (typeof value === "number") {
    return value;
  }
  if (typeof value === "string") {
    return parseFloat(value.replace("s", ""));
  }
  if (value && typeof value === "object") {
    return (parseFloat(value.seconds) || 0) + (parseFloat(value.nanos) || 0) / 1e9;
  }
  return NaN;
}